import React from "react";
import { ModalStyle } from "../Style";

const GenericModal = ({ div, init }) => {
  return (
    <ModalStyle
      className="animate__animated animate__fadeIn"
      onClick={(e) => {
        e.preventDefault();
        init(null);
      }}
    >
      {div}
    </ModalStyle>
  );
};
export default GenericModal;
